import { RootState } from '../store';
import { RejectionReason } from '../slices/filesSlice';

export const selectFiles = (state: RootState) => state.files.files;
export const selectPendingFiles = (state: RootState) => state.files.pendingFiles;
export const selectHasValidationResults = (state: RootState) =>
  state.files.pendingFiles.length > 0 || state.files.rejectedFiles.length > 0;
export const selectRejectedByReason = (reason: RejectionReason) => (state: RootState) =>
  state.files.rejectedFiles.filter(f => f.reason === reason).map(f => f.name);